import { createActionPlan, deleteActionPlanStep, patchActionPlan } from 'apis/ActionPlansAPI';
import { ACTION_PLAN_SOURCE } from 'constants/actionPlan';
import { ActionPlanDetailsType } from 'types/actionPlans';

import { ACTION_PLAN_STATUS } from './constants';
import { ActionPlanFormValues } from './CreateEditActionPlansModalTypes';
import {
  getActionPlanItemsPayload,
  getKeptActionPlanStepIds,
  getNewActionPlanItemsPayload,
  getSubmittedActionPlanItems,
} from './utils';

type SaveActionPlanFormParams = {
  actionPlanId: number;
  values: ActionPlanFormValues;
  currentDetails: ActionPlanDetailsType;
};

type CreateActionPlanFormParams = {
  communityId: number;
  values: ActionPlanFormValues;
  sourceInsights?: number[];
};

const getActionPlanFormPayload = (values: ActionPlanFormValues) => ({
  name: values.name.trim(),
  description: values.description,
  focus_area_id: values.focus_area_id ?? null,
  owner_id: values.owner_id ?? null,
  due_date: values.due_date ? values.due_date.format('YYYY-MM-DD') : null,
});

export const saveActionPlanForm = async ({ actionPlanId, values, currentDetails }: SaveActionPlanFormParams) => {
  const currentStepIds = currentDetails.steps.map((step) => step.id);
  const submittedItems = getSubmittedActionPlanItems(values.items);
  const keptStepIds = getKeptActionPlanStepIds(values.items);

  await patchActionPlan(actionPlanId, {
    ...getActionPlanFormPayload(values),
    items: getActionPlanItemsPayload(submittedItems, ACTION_PLAN_STATUS.NOT_STARTED, currentDetails.steps),
  });

  const deletedStepIds = currentStepIds.filter((id) => !keptStepIds.includes(id));
  if (deletedStepIds.length) {
    await Promise.all(deletedStepIds.map((id) => deleteActionPlanStep(id)));
  }
};

export const createActionPlanFromForm = async ({ communityId, sourceInsights, values }: CreateActionPlanFormParams) =>
  createActionPlan({
    community_id: communityId,
    ...getActionPlanFormPayload(values),
    source: ACTION_PLAN_SOURCE.USER_ADDED,
    ...(sourceInsights?.length ? { source_insights: sourceInsights } : {}),
    status: ACTION_PLAN_STATUS.NOT_STARTED,
    items: getNewActionPlanItemsPayload(getSubmittedActionPlanItems(values.items), ACTION_PLAN_STATUS.NOT_STARTED),
  });
